export type McpScopeLevel = "user" | "org" | "enterprise" | "global";

export const MCP_SCOPE_LEVELS: readonly McpScopeLevel[] = [
  "user",
  "org",
  "enterprise",
  "global",
];

export type McpManageableScopeLevel = Exclude<McpScopeLevel, "global">;

export const MCP_MANAGEABLE_SCOPE_LEVELS: readonly McpManageableScopeLevel[] = [
  "user",
  "org",
  "enterprise",
];
